import React, { FC } from 'react';
import { Box, Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AnimalType } from '../../../../../models/animal';
import { NotificationRuleRegionType } from '../../../../../models/injection';
import { AnimalTypeSelect } from '../../../../../elements';
import { DayOfWeek } from '../../../../../models/common';

export interface IMinAnimalRegTab {
  animalType: AnimalType;
  setAnimalType: React.Dispatch<React.SetStateAction<AnimalType>>;
  weekNumber: string;
  setWeekNumber: (newWeekNumber: string) => void;
  dayOfTheWeek: DayOfWeek;
  setDayOfTheWeek: (newDay: DayOfWeek) => void;
  minRegistered: string;
  setMinRegistered: React.Dispatch<React.SetStateAction<string>>;
  notificationRuleRegionType?: NotificationRuleRegionType;
}

const MinAnimalRegTab: FC<IMinAnimalRegTab> = (props) => {
  const { t } = useTranslation();

  const { animalType, setAnimalType, minRegistered, setMinRegistered } = props;

  return (
    <Box p={1}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={6}>
          <AnimalTypeSelect fullWidth value={animalType} onAnimalTypeChange={(a) => setAnimalType(a)} allowAny />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label={t('f-notif-rule-min-reg-title')}
            variant="outlined"
            fullWidth
            size="small"
            type="number"
            value={minRegistered}
            onChange={(e) => setMinRegistered(e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MinAnimalRegTab;
